export default __webpack_public_path__ + "static/benefit-2-5dccabe277117e06bac695496fe4ae72.webp";